<template>
    <u-user-items-icon-text>
        <slot />
    </u-user-items-icon-text>
</template>

<script>
import UUserItemsIconText from "@/components/publish/styles/headers/u-user-items-icon-text.vue";

export default {
    props: {},
    components: {
        UUserItemsIconText,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
